"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { TrendingUp, Target, ShoppingCart, Award } from "lucide-react";
export default function Servicios() {
  const {
    ref: section1Ref,
    isVisible: section1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section2Ref,
    isVisible: section2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section3Ref,
    isVisible: section3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section4Ref,
    isVisible: section4Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    icon: TrendingUp,
    title: "Gestión Comercial",
    description: "Especialización en canales de ferretería, suministro industrial y materiales de construcción con redes multicartera.",
    ref: section1Ref,
    isVisible: section1Visible
  }, {
    icon: Target,
    title: "Marketing Estratégico",
    description: "Consultoría en marketing digital y estratégico orientado a resultados y crecimiento sostenido.",
    ref: section2Ref,
    isVisible: section2Visible
  }, {
    icon: ShoppingCart,
    title: "E-commerce y Ventas Digitales",
    description: "Estrategias de ventas digitales y optimización de plataformas e-commerce para maximizar conversiones.",
    ref: section3Ref,
    isVisible: section3Visible
  }, {
    icon: Award,
    title: "Branding y Posicionamiento",
    description: "Desarrollo de marca y posicionamiento estratégico para destacar en el mercado B2B.",
    ref: section4Ref,
    isVisible: section4Visible
  }];
  return <section className="bg-background py-16 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
            Servicios
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Soluciones estratégicas y orientadas a resultados para impulsar su presencia comercial y digital.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} ref={service.ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${service.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`} style={{
            transitionDelay: `${i * 200}ms`
          }}>
                <Card className="h-full hover:-translate-y-0.5 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] border border-border">
                  <CardHeader>
                    <div className="w-14 h-14 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                      <Icon className="w-7 h-7 text-primary" strokeWidth={2} />
                    </div>
                    <CardTitle className="text-xl font-semibold text-foreground">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-muted-foreground leading-relaxed">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}